import React from 'react'

export const Portfolio = () => {
    return (
        <div>
            <h1>Portfolio Screen</h1>
        </div>
    )
}
